import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "input",
    "pricesContainer",
    "amountUntaxed",
    "amountTaxed",
  ]

  static values = {
    vat: { type: Number, default: 1.2 },
    maxUntaxed: { type: Number, default: 0 },
    inputType: { type: String, default: 'untaxed' }
  }

  initialize() {
    this.updateAmounts({ target: this.inputTarget });
  }

  updateAmounts(event) {
    const toFrench = x => new Intl.NumberFormat('fr-FR').format(x);

    let $eventTarget = $(event.target);
    let amount = parseInt($eventTarget.val());
    let amountUntaxed;
    let amountTaxed;
    let error = false;
    let errorMessage = "Le montant est trop élevé";

    if(!$eventTarget.is(':visible')){
      return;
    }

    if(this.inputTypeValue == 'untaxed') {
      amountUntaxed = amount;
      amountTaxed = amountUntaxed * this.vatValue;
    } else {
      amountTaxed = amount;
      amountUntaxed = amountTaxed / this.vatValue;
    }

    $(this.amountUntaxedTarget).html(toFrench(((amountUntaxed || 0) / 100).toFixed(2)));
    $(this.amountTaxedTarget).html(toFrench(((amountTaxed || 0) / 100).toFixed(2)));
    $(this.pricesContainerTarget).removeClass('hide');

    if(this.maxUntaxedValue > 0) {
      if(amountUntaxed > this.maxUntaxedValue) {
        errorMessage = "Le montant est trop élevé";
        error = true;
        this.addError($(this.element), errorMessage);
      } else if(!amountUntaxed || amountUntaxed < 0) {
        errorMessage = "Le montant ne peut être vide ou nul";
        error = true;
        this.addError($(this.element), errorMessage);
      } else {
        errorMessage = "";
        error = false;
        this.removeError($(this.element));
      }
    }

    const pricesChangeEvent = new CustomEvent("pretty-price--changed", {
      bubbles: true,
      detail: {
        amountUntaxed: amountUntaxed,
        amountTaxed: amountTaxed,
        maxUntaxed: this.maxUntaxedValue,
        vat: this.vatValue,
        error: error,
        errorMessage: errorMessage
      },
    });

    this.element.dispatchEvent(pricesChangeEvent);
  }

  addHelpBlock($changedElementFormGroup, message){
    var html_message = "<span class='help-block'>" + message + "</span>";

    if($('.help-block', $changedElementFormGroup).length == 0){
      $changedElementFormGroup.append(html_message);
    } else {
      $('.help-block', $changedElementFormGroup).html(message);
    }
  }

  addError($changedElementFormGroup, message) {
    this.addHelpBlock($changedElementFormGroup, message);
    $changedElementFormGroup.addClass('has-error');

    $('[type="submit"]').prop('disabled', true);
  }

  removeError($changedElementFormGroup) {
    if($changedElementFormGroup.hasClass('has-error')) {
      $('.help-block', $changedElementFormGroup).remove();
      $changedElementFormGroup.removeClass('has-error');

      $('[type="submit"]').prop('disabled', false);
    }
  }
}
